/* candy-bsl3k-slider.js — THE Best Sellers carousel, as a shared engine.

   Lifted verbatim out of sections/candy-top-sellers.liquid on 2026-08-22, because the
   product page's "Goes well with" / "Recently viewed" rows have to be the same slider,
   not a similar one (client: "the slider is not same functionality as homepage slider,
   it should be exactly 100% same as homepage slider on desk and mob"). They used to run a
   native overflow-x scroller — same cards, same arrows, same dots, but a different feel:
   free scrolling instead of card-by-card, no infinite wrap, no centred card, no momentum
   throw. Two engines meant two behaviours, and any later fix to one would have to be
   remembered for the other.

   So there is now exactly one implementation and three callers. Nothing in the engine
   changed in the move except the two lines that found its root: it takes `root` as an
   argument instead of reading document.currentScript, and it refuses to wire the same
   root twice (the PDP re-calls it when "Recently viewed" finishes building its cards).

   `root` must be an element that contains .custom-bsl3k__viewport > .custom-bsl3k__rail,
   with the cards as .custom-bsl3k__card, and it must be the DIRECT parent of the viewport
   (the dot rail is inserted as root's child, straight after it). Everything else — the
   geometry, the drag, the wrap, the dots — comes from candy-top-sellers.css, which is why
   both pages are the same slider by construction rather than by copying. */
window.candyBsl3kSlider = function(root){
  if(!root || root.__bsl3kWired) return;
  root.__bsl3kWired = true;
  var isMob = !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches);

  /* Two rails can exist (see the `mobile_product` blocks in the markup). Bind to
     the one this breakpoint actually shows — binding to the hidden one would
     measure a display:none element and give every card a width of 0. */
  var viewport = root.querySelector(isMob ? '.custom-bsl3k__vp--mob' : '.custom-bsl3k__vp--desk')
              || root.querySelector('.custom-bsl3k__viewport');
  if(!viewport) return;
  var track = viewport.querySelector('.custom-bsl3k__rail');
  var prev = viewport.querySelector('.custom-bsl3k__nav--prev');
  var next = viewport.querySelector('.custom-bsl3k__nav--next');
  if(!track) return;

  /* MOBILE (<=768px): the design is a centred snap carousel, not the desktop
     marquee — run that instead and never initialise the math engine, which
     would write inline transform/width/height over the mobile layout.
     Desktop falls straight through and is unaffected. */
  if(isMob){ initMobileSnap(); return; }

  var cards = [].slice.call(track.querySelectorAll('.custom-bsl3k__card'));
  var UNIQ = cards.length;
  if(!UNIQ) return;
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- WHY THE RING IS PADDED ------------------------------------------
     With as many products as there are VISIBLE slots there is nowhere
     off-stage for a card to wrap through: the one leaving the far left has
     to become the far right, and with nothing hiding the move it flies
     across the middle of the row. So a short list is duplicated; the spare
     copies live in hidden slots (|offset| >= 3) parked outside the frame at
     opacity 0, and the wrap happens out there where nothing is visible. */
  var REP = UNIQ < 7 ? 2 : 1;
  if(REP > 1){
    var frag = document.createDocumentFragment();
    for(var r = 1; r < REP; r++){
      for(var c = 0; c < UNIQ; c++){
        var cl = cards[c].cloneNode(true);
        cl.setAttribute('aria-hidden', 'true');       /* the copies are decoration */
        cl.removeAttribute('id');
        frag.appendChild(cl);
      }
    }
    track.appendChild(frag);
    cards = [].slice.call(track.querySelectorAll('.custom-bsl3k__card'));
  }
  var N = cards.length;

  /* ---- the slots, measured from the centre outwards, in CARD WIDTHS so the
     geometry follows the vw sizing at any viewport. d is a FLOAT, not an
     index: mid-drag a card sits between two slots and interpolates, which is
     what lets the row be dragged freely through several cards instead of
     sliding as one rigid block. */
  /* EVERY CARD THE SAME SIZE (client 2026-08-20: "make this slider on desktop same
     size all"). This was a spotlight: the centre card at scale 1 with its neighbours
     stepping down to 0.715 and 0.64 and dimming as they went.

     The SPACING had to change with it, and that is the part that is not obvious. x is
     measured in CARD WIDTHS, and 0.9193 — less than one full width — only worked
     because the neighbours were shrunk: at full size, cards pitched 0.9193 apart
     overlap by 8% of their own width. 1.05 is one card plus a 5% gutter, which is the
     same proportional gap the mobile rail uses (3.155 / 60.146 = 0.0525).

     Consequence worth knowing: full-size cards take more room, so the row now shows
     three complete cards and a slice of the fourth and fifth, where the spotlight fitted
     five. That is arithmetic, not a setting — 86.1111vw of viewport divided by a
     22.3611vw card is 3.85 cards. Showing five at equal size would mean a ~16.3vw card,
     and every type size, chip and disc inside it is derived from the 22.3611vw width.

     Opacity is flat across the visible slots too — a card that is the same size but
     dimmer still reads as secondary. The fade to 0 is kept for the OFF-STAGE slots
     only; that is what hides the wrap, and removing it would let cards visibly pop in
     and out at the edges of the row. */
  var ANCH = [
    { x: 0,    s: 1, o: 1 },   /* centre */
    { x: 1.05, s: 1, o: 1 },   /* near   */
    { x: 2.10, s: 1, o: 1 },   /* far — clipped by the section edge, reads as a peek */
    { x: 3.15, s: 1, o: 0 }    /* off-stage, invisible: the wrap happens out here */
  ];
  var CW = 0;                                   /* card width in px */
  function measure(){ CW = cards[0] ? cards[0].offsetWidth : 0; }

  function slotFor(d){
    var a = Math.abs(d), sgn = d < 0 ? -1 : 1;
    /* past the last anchor the slots just keep marching out at the same 1.05 pitch,
       at full size and zero opacity — same numbers as ANCH above, so a card leaving
       the row and a card parked off-stage are never a different width */
    if(a >= 3) return { x: (2.10 + (a - 2) * 1.05) * sgn, s: 1, o: 0, z: 0 };
    var i = Math.floor(a), t = a - i, A = ANCH[i], B = ANCH[i + 1];
    return {
      x: (A.x + (B.x - A.x) * t) * sgn,
      s:  A.s + (B.s - A.s) * t,
      o:  A.o + (B.o - A.o) * t,
      z:  10 - Math.round(a * 2)
    };
  }

  var cur = 0, pos = 0;
  var down = false, dragged = false, startX = 0, startPos = 0;
  var lastMoveX = 0, lastMoveT = 0, vel = 0;

  /* shortest signed distance from the centre — the loop is infinite in BOTH
     directions with no seam. `at` may be fractional (mid-drag). */
  function offsetOf(i, at){
    if(at === undefined) at = cur;
    var d = (i - at) % N;
    if(d >  N / 2) d -= N;
    if(d < -N / 2) d += N;
    return d;
  }

  /* write-on-change: an identical transform still invalidates style if re-written */
  var lastTf = [], lastOp = [], lastMid = [];
  function render(at){
    if(at === undefined) at = cur;
    if(!CW) measure();
    for(var i = 0; i < N; i++){
      var sl = slotFor(offsetOf(i, at));
      var tf = 'translate3d(' + ((sl.x * CW - CW / 2).toFixed(2) / window.innerWidth * 100) + 'vw, -50%, 0) scale(' + sl.s.toFixed(4) + ')';
      if(tf !== lastTf[i]){ cards[i].style.transform = tf; lastTf[i] = tf; }
      var o = +sl.o.toFixed(3);
      if(o !== lastOp[i]){
        cards[i].style.opacity = o;
        cards[i].style.pointerEvents = o > 0.05 ? 'auto' : 'none';
        lastOp[i] = o;
      }
      cards[i].style.zIndex = sl.z;
      var isMid = Math.abs(offsetOf(i, at)) < 0.5;
      if(isMid !== lastMid[i]){ cards[i].classList.toggle('is-mid', isMid); lastMid[i] = isMid; }
    }
    var live = ((Math.round(at) % N) + N) % N;
    for(var k = 0; k < dotEls.length; k++) dotEls[k].classList.toggle('is-on', k === (live % UNIQ));
  }

  /* ---- MOVEMENT IS A TWEEN OF `pos`, NOT A CLASS SWAP -------------------
     A CSS transition interpolates each card's OLD slot straight to its NEW
     one. That is fine for a single step, but on a multi-step move (a dot
     click, or a drag that travelled three cards) a card whose slot flips
     from the far LEFT to the far RIGHT took the direct route — straight
     through the middle of the row, in full view, against the direction of
     travel. That is the "coming from the inverse direction" fault.

     Tweening the POSITION instead means every card walks the ring one slot
     at a time. A card leaving the left edge passes through the hidden slots
     (|offset| >= 3, opacity 0, parked outside the frame) before it reappears
     on the right, so a wrap can never be seen. ---------------------------- */
  var raf = null, twFrom = 0, twTo = 0, twT0 = 0, twDur = 0;
  var targetIdx = 0;

  function easeOut(t){ return 1 - Math.pow(1 - t, 3); }

  var noSnap = false;
  function settle(){
    raf = null;
    if(noSnap){
      /* FREE-SCROLL rest: keep the fractional position exactly where the glide ended, so the
         rail is not pulled onto a card centre. `cur` follows the nearest card only so the arrows
         and dots keep stepping sensibly. Normalised so pos never drifts unbounded. */
      noSnap = false;
      pos = ((pos % N) + N) % N;
      cur = Math.round(pos) % N;
      track.classList.remove('is-moving');
      render(pos);
      return;
    }
    cur = ((Math.round(twTo) % N) + N) % N;
    pos = cur;
    track.classList.remove('is-moving');
    render(pos);
  }

  /* glide to a FRACTIONAL target and stop there -- no rounding, unlike animateTo */
  function glideTo(target){
    if(raf){ cancelAnimationFrame(raf); raf = null; }
    twFrom = pos; twTo = target; noSnap = true;
    targetIdx = ((Math.round(target) % N) + N) % N;
    twDur = reduceMotion.matches ? 0 : 260;
    if(!twDur){ settle(); return; }
    twT0 = performance.now();
    track.classList.add('is-moving');
    raf = requestAnimationFrame(tick);
  }

  function tick(now){
    var t = Math.min(1, (now - twT0) / twDur);
    pos = twFrom + (twTo - twFrom) * easeOut(t);
    render(pos);
    if(t < 1) raf = requestAnimationFrame(tick);
    else settle();
  }

  function animateTo(target){
    if(raf){ cancelAnimationFrame(raf); raf = null; }
    /* shortest signed route around the ring — never the long way */
    var d = (target - pos) % N;
    if(d >  N / 2) d -= N;
    if(d < -N / 2) d += N;
    twFrom = pos;
    twTo = pos + d;
    targetIdx = ((Math.round(twTo) % N) + N) % N;
    var steps = Math.max(1, Math.abs(d));
    twDur = reduceMotion.matches ? 0 : Math.min(900, 380 + (steps - 1) * 140);
    if(!twDur){ settle(); return; }
    twT0 = performance.now();
    track.classList.add('is-moving');
    raf = requestAnimationFrame(tick);
  }

  function go(i){ animateTo(Math.round(i)); }

  /* ---- dots: one per REAL product, not per copy ---- */
  var dotWrap = root.querySelector('.custom-bsl3k__dots');
  if(!dotWrap){
    dotWrap = document.createElement('div');
    dotWrap.className = 'custom-bsl3k__dots';
    /* straight after the carousel — anchoring to a direct child of root, because
       the arrows are no longer one (they moved inside the viewport) */
    if(viewport.nextSibling) root.insertBefore(dotWrap, viewport.nextSibling);
    else root.appendChild(dotWrap);
  }
  dotWrap.innerHTML = '';
  for(var dd = 0; dd < UNIQ; dd++){
    (function(dd){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'custom-bsl3k__dot';
      b.setAttribute('aria-label', 'Go to product ' + (dd + 1));
      b.addEventListener('click', function(){
        /* jump to whichever copy of this product is closest — shortest path */
        var best = -1, bd = 1e9;
        for(var i = 0; i < N; i++){
          if(i % UNIQ !== dd) continue;
          var dist = Math.abs(offsetOf(i, pos));   /* measured from where it IS, not from a stale cur */
          if(dist < bd){ bd = dist; best = i; }
        }
        if(best > -1) animateTo(best);
      });
      dotWrap.appendChild(b);
    })(dd);
  }
  var dotEls = dotWrap.querySelectorAll('.custom-bsl3k__dot');

  /* stepping off targetIdx, not cur: mid-tween `cur` is still the OLD index, so
     two quick clicks would both aim at the same neighbour */
  if(prev) prev.addEventListener('click', function(){ animateTo(targetIdx - 1); });
  if(next) next.addEventListener('click', function(){ animateTo(targetIdx + 1); });

  /* click a side card to pull it to the centre. DELEGATED, and hit-tested by
     coordinate rather than trusting e.target: the drag calls setPointerCapture
     on the viewport, and while a capture is (or has just been) active Chrome
     retargets the follow-up click to the CAPTURING element, so a listener bound
     to the card itself never fires. */
  viewport.addEventListener('click', function(e){
    if(dragged) return;
    /* AND NOT WHILE IT IS STILL MOVING (same client note: "if you go to click on one,
       sometimes when it jumps it clicks on a different product"). The hit test below reads
       whatever is under the cursor at the instant of the click, so a click that lands during
       the settle opens the card that has slid into that spot, not the one that was aimed at.
       While `raf` is running the row is mid-tween, so the click is dropped instead. */
    if(raf){ e.preventDefault(); e.stopPropagation(); return; }
    var hit = document.elementFromPoint(e.clientX, e.clientY);
    if(!hit || !hit.closest) return;
    if(hit.closest('.custom-bsl3k__nav') || hit.closest('.custom-bsl3k__add')) return;
    var el = hit.closest('.custom-bsl3k__card');
    if(!el) return;
    var i = cards.indexOf(el);
    /* EVERY card's link opens, not only the spotlit one (client 2026-08-22: "when I click
       left/right, instead of opening it centres"). A side card used to be a "bring me
       here"; now a click on its product link goes to the product, and only a click on
       the card's empty surface (no link under the cursor) pulls it to the centre. */
    if(hit.closest('a[href]') || i === cur){
      /* THE SPOTLIT CARD'S LINKS HAVE TO BE FOLLOWED BY HAND (client 2026-08-08:
         "click not working due to drag i think" — right diagnosis). The retargeting
         described above does not only break listeners bound to the card: it breaks
         the <a> too. Chrome dispatches this click at the VIEWPORT, so the anchor
         under the cursor is never the click target and its default navigation never
         runs — the status bar shows the href on hover, and nothing happens on click.
         Side cards were fine because they call go(i) instead of relying on the link. */
      var a = hit.closest('a[href]');
      if(!a) return;
      e.preventDefault();
      if(a.target === '_blank') window.open(a.href, '_blank', 'noopener');
      else window.location.href = a.href;
      return;
    }
    /* FREE SCROLL (Arsalan 2026-09-22 "mamuli sa drag per jerk"): a click on a card's empty
       surface used to go(i) and pull that card to the centre. On a rail that no longer centres,
       that re-centre played as a jerk after the smallest drag -- the rail moved a few pixels,
       then the click yanked it onto a slot. So an empty-surface click now does nothing; a click
       on the card's product link still opens it (handled above). */
    return;
  });

  /* ---- FREE DRAG: the drag moves a FRACTIONAL position, so a long drag travels
     several cards and the release snaps to whichever one you landed nearest.
     A flick adds up to two more. ---- */
  viewport.addEventListener('dragstart', function(e){ e.preventDefault(); });

  viewport.addEventListener('pointerdown', function(e){
    /* Only the primary button starts a drag. Capturing a middle/right click here
       retargets Chrome's auxclick away from the product anchor. */
    if(e.button !== 0) return;
    if(e.target.closest && (e.target.closest('.custom-bsl3k__nav') || e.target.closest('.custom-bsl3k__add'))) return;
    down = true; dragged = false;
    if(raf){ cancelAnimationFrame(raf); raf = null; track.classList.remove('is-moving'); }
    startX = e.clientX; startPos = pos;      /* grab from wherever the tween got to */
    lastMoveX = e.clientX; lastMoveT = performance.now(); vel = 0;
    measure();
    try { viewport.setPointerCapture(e.pointerId); } catch(err){}
  });

  viewport.addEventListener('pointermove', function(e){
    if(!down) return;
    var dx = e.clientX - startX;
    if(Math.abs(dx) > 3) dragged = true;   /* 3px: a tiny drag is a drag, so its release is never a click */
    pos = startPos - dx / (CW * 1.05);          /* one card = one slot step — MUST track ANCH's pitch */
    var now = performance.now(), dt = now - lastMoveT;
    if(dt > 0){ vel = (e.clientX - lastMoveX) / dt; lastMoveX = e.clientX; lastMoveT = now; }
    render(pos);
  });

  function release(e){
    if(!down) return;
    down = false;
    try { viewport.releasePointerCapture(e.pointerId); } catch(err){}
    /* NEVER SETTLE BACKWARDS (Arsalan 2026-09-22: "when i slide it's coming back if there is a
       little bit ahead -- it should not come back"; the client the same morning: "the bestseller
       scroll bar glitches slightly on a computer, it jumps slightly back and forth at certain
       points"). `Math.round(pos + boost)` reversed the rail at the end of every drag that had
       passed a boundary by less than half a card: the hand stopped 1.3 cards in, the rail slid
       back to 1.0 -- the "back and forth". Now the rail settles on the NEXT boundary in the
       direction of travel, 8% tolerance so a few pixels past a boundary do not jump a whole extra
       card, under 12% of a card is not a drag. The velocity throw is gone with it: the rail stops
       at the first boundary beyond where the hand let go, which is what a mouse user expects.
       Same rule on the four coverflow rails. The commit rule below is kept only as its comment. */
    /* FREE SCROLL, SITS EXACTLY WHERE LEFT (Arsalan 2026-09-22: "after left/right scroll drag on
       desktop it should not fix on centre" then "still not sitting where i leave"). Every slot in
       this rail is full size, so there is no card to centre. On release the rail STOPS on the spot
       -- no glide, no momentum, no rounding to a slot -- so it cannot drift, spring back or lock to
       a centre. Arrows and dots still step whole cards from the nearest. */
    if(raf){ cancelAnimationFrame(raf); raf = null; }
    pos = ((pos % N) + N) % N;
    cur = Math.round(pos) % N;
    track.classList.remove('is-moving');
    render(pos);
    setTimeout(function(){ dragged = false; }, 0);
  }
  viewport.addEventListener('pointerup', release);
  viewport.addEventListener('pointercancel', function(){
    if(!down) return;
    down = false;
    glideTo(pos);                                      /* free-scroll: stop where it is, no centre snap */
    setTimeout(function(){ dragged = false; }, 0);
  });

  measure();
  render();
  root.classList.add('custom-bsl3k--ready');

  var rz, rzW = window.innerWidth;
  window.addEventListener('resize', function(){
    /* WIDTH-ONLY (client 2026-08-21: "sliding fast on top and bottom the things got broken for few seconds"). On a phone the browser bar slides away as you scroll and back as you stop, and each time that is a `resize` — of HEIGHT only. This handler used to re-run layout() regardless, so every carousel on the page re-measured, snapped back to its nearest card and rebuilt its chrome a tenth of a second into every fast scroll. Nothing here depends on the height, so a resize that leaves the width alone is ignored. */
    if(window.innerWidth === rzW) return;
    rzW = window.innerWidth;
    clearTimeout(rz);
    rz = setTimeout(function(){ measure(); lastTf = []; render(); }, 100);
  });
  window.addEventListener('load', function(){ measure(); lastTf = []; render(); });

  /* ---- MOBILE carousel: CLONE-FREE infinite math engine (client 2026-07-30
          "why is it cloning slides?" — reference build Desktop/slider). One
          card centred at full scale with both neighbours peeking at 0.85,
          dots underneath — the design is UNCHANGED; only the machinery is:
          the SAME cards are placed by modular math each frame and wrap
          off-screen, so no cloned sets and no teleport hop. The centred
          card's scale now eases with the drag instead of snapping after it.
          Desktop never reaches this — the branch above returns. ---- */
  function initMobileSnap(){
    var items = Array.prototype.slice.call(track.querySelectorAll('.custom-bsl3k__card'));
    var n = items.length;
    if(!n) return;
    var reduceMo = matchMedia('(prefers-reduced-motion: reduce)');

    var W = 0, cardW = 0, gap = 0, centre0 = 0, seam = 0, total = 0, vpw = 0, offset = 0, target = 0, raf = null;
    function mod(a, m){ return ((a % m) + m) % m; }
    function setMoving(on){ track.classList.toggle('is-moving', on); }

    var dots = document.createElement('div');
    dots.className = 'custom-bsl3k__dots';
    items.forEach(function(c, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'custom-bsl3k__dot';
      b.setAttribute('aria-label', 'Show product ' + (i + 1) + ' of ' + n);
      b.addEventListener('click', function(){
        /* shortest way round the loop, never the long way */
        var live = mod(Math.round(target / W), n);
        var d1 = mod(i - live, n);
        var delta = d1 > n / 2 ? d1 - n : d1;
        target = (Math.round(target / W) + delta) * W;
        animate();
      });
      dots.appendChild(b);
    });
    /* anchor on the VIEWPORT, not the navrow: the arrows moved inside the viewport
       for the desktop spotlight, so they stopped being a direct child of root and
       insertBefore threw "node is not a child of this node" — which killed the rest
       of initMobileSnap and left mobile with no dot rail at all. */
    if(viewport.nextSibling) root.insertBefore(dots, viewport.nextSibling);
    else root.appendChild(dots);

    /* WRITE-ON-CHANGE + QUANTISED, same as the desktop engine (client 2026-08-08:
       "on desktop very smooth sliding, on mob not smooth"). Two things were costing
       frames here that desktop had already fixed:
         - the raw float went straight into the transform string, so consecutive
           frames produced different strings for what is visually the same position
           and every card was rewritten every frame;
         - an identical transform still invalidates style even when nothing moved.
       Rounding to 2dp / 4dp makes most frames a no-op for most cards. */
    var lastTf = [];
    function render(){
      for(var i = 0; i < n; i++){
        /* branchless wrap; the seam sits past the fully-off-screen point, so
           a leaving card slides all the way out instead of teleporting away
           while its corner is still visible (client 2026-07-30 "its removing
           the slide") */
        var x = mod(i * W - offset + seam, total) - seam;
        /* centred card scale 1, neighbours ease to the design's .85 */
        var s = 1 - 0.15 * Math.min(Math.abs(x) / W, 1);
        var tf = 'translate3d(' + ((x + centre0).toFixed(2) / window.innerWidth * 100) + 'vw,0,0) scale(' + s.toFixed(4) + ')';
        if(tf !== lastTf[i]){ items[i].style.transform = tf; lastTf[i] = tf; }
      }
    }
    var liveIdx = -1;
    function syncDots(force){
      var live = W ? mod(Math.round(offset / W), n) : 0;
      if(live === liveIdx && !force) return;
      liveIdx = live;
      items.forEach(function(c, i){ c.classList.toggle('is-cur', i === live); });
      Array.prototype.forEach.call(dots.children, function(d, i){
        d.classList.toggle('is-on', i === live);
        d.setAttribute('aria-current', i === live ? 'true' : 'false');
      });
    }
    function layout(){
      var index = W ? Math.round(offset / W) : 0;    /* remember the card BEFORE W changes */
      vpw = track.clientWidth;
      var iw = window.innerWidth;
      /* measure the CSS-rendered card, don't recompute vw in JS — innerWidth
         can disagree with the CSS viewport (scrollbars/zoom) and the maths
         drifted off the real layout */
      cardW = items[0].offsetWidth || iw * 0.60146;
      gap = cardW * (3.155 / 60.146);                /* design gap on the same basis */
      W = cardW + gap; total = n * W;
      centre0 = (vpw - cardW) / 2;                   /* active slot dead centre */
      seam = centre0 + cardW + gap;                  /* teleport only once fully off-screen left */
      offset = target = index * W;
      render(); syncDots(true);
      requestAnimationFrame(function(){
        var h = 0;
        for(var i = 0; i < n; i++) if(items[i].offsetTop + items[i].offsetHeight > h) h = items[i].offsetTop + items[i].offsetHeight;   /* + offsetTop: the homepage phone cards sit below their outside tab (2026-09-28) */
        /* minHeight, not height (2026-08-22). The mobile rail's stylesheet rule is
           `height: auto !important; min-height: 90vw`, so the inline height this used
           to write never applied and the rail stayed at exactly 90vw — fine while every
           card was 90vw, but the category/texture chips made the cards taller than that
           and their bottoms, radius and all, were being clipped by the rail's
           overflow:hidden (client: "why cutting this section mobile radius at bottom").
           min-height is not !important in the sheet, so this one wins. */
        if(h) track.style.minHeight = (h / window.innerWidth * 100) + 'vw';
      });
    }
    var lastT = 0;
    function tick(t){
      var dt = Math.min((t - lastT) / 1000, 0.05);
      lastT = t;
      var diff = target - offset;
      if(Math.abs(diff) < 0.5){
        offset = target = mod(target, total);
        render(); syncDots(); raf = null; setMoving(false); return;
      }
      offset += diff * (1 - Math.exp(-dt * 10));
      render(); syncDots();
      raf = requestAnimationFrame(tick);
    }
    function animate(){
      if(reduceMo.matches){ offset = target = mod(target, total); render(); syncDots(); setMoving(false); return; }
      setMoving(true);
      if(!raf){ lastT = performance.now(); raf = requestAnimationFrame(tick); }
    }

    /* 1:1 drag + momentum; touch-action: pan-y keeps vertical page scroll native */
    var dragging = false, startX = 0, startOffset = 0, lastX = 0, lastMoveT = 0, velocity = 0, captured = false;
    var moveRaf = null, pendingX = 0;
    track.addEventListener('pointerdown', function(e){
      if(e.button !== 0) return;
      dragging = true; captured = false;
      startX = lastX = pendingX = e.clientX; startOffset = offset;
      velocity = 0; lastMoveT = performance.now();
      if(raf){ cancelAnimationFrame(raf); raf = null; }
      /* is-moving is what turns on `will-change: transform` — and the drag is the
         one phase where it matters most. It was only ever set for the settle
         animation, so during the actual finger drag the cards were NOT promoted:
         every frame repainted eight rounded, overflow-clipped cards, each with a
         three-layer gradient background. That is the jank. */
      setMoving(true);
    });
    /* COALESCE TO ONE RENDER PER FRAME. Touch digitisers sample faster than the
       display refreshes — often 120Hz against a 60Hz screen — so rendering straight
       out of pointermove did the work twice for every frame actually shown. Keep the
       latest x, draw it once on the next frame. */
    track.addEventListener('pointermove', function(e){
      if(!dragging) return;
      if(!captured && Math.abs(e.clientX - startX) > 5){
        captured = true;
        try{ track.setPointerCapture(e.pointerId); }catch(err){}
      }
      var now = performance.now(), dt = now - lastMoveT;
      if(dt > 0) velocity = (e.clientX - lastX) / dt;
      lastX = pendingX = e.clientX; lastMoveT = now;
      if(moveRaf === null){
        moveRaf = requestAnimationFrame(function(){
          moveRaf = null;
          if(!dragging) return;
          offset = target = startOffset - (pendingX - startX);
          render(); syncDots();
        });
      }
    });
    function endDrag(){
      if(!dragging) return;
      dragging = false;
      /* a coalesced frame may still be queued, and its offset would be one sample
         behind the finger. Drop it and settle from the last real sample instead. */
      if(moveRaf !== null){ cancelAnimationFrame(moveRaf); moveRaf = null; }
      offset = target = startOffset - (lastX - startX);
      var moved = offset - startOffset;
      var momentum = -velocity * 120;
      var idx = Math.round((offset + momentum) / W);
      var startIdx = Math.round(startOffset / W);
      /* a small deliberate drag still advances one card instead of springing
         back (client 2026-07-30 "little drag reverts, requires full drag") */
      if(idx === startIdx && Math.abs(moved) > W * 0.12) idx = startIdx + (moved > 0 ? 1 : -1);
      /* ONE GESTURE = ONE CARD (client 2026-08-02) — a quick flick could
         otherwise carry several cards through the momentum throw */
      if(idx > startIdx + 1) idx = startIdx + 1;
      else if(idx < startIdx - 1) idx = startIdx - 1;
      target = idx * W;
      animate();
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', function(e){ e.preventDefault(); });
    /* a real drag must never trigger the card's links or the Add disc; and
       tapping a PEEKING card centres it instead of firing its links
       (client 2026-07-30 "left right slide click should become them active") */
    track.addEventListener('click', function(e){
      if(Math.abs(lastX - startX) > 5){ e.preventDefault(); e.stopPropagation(); return; }
      var item = e.target.closest ? e.target.closest('.custom-bsl3k__card') : null;
      var i = item ? items.indexOf(item) : -1;
      if(i < 0) return;
      var live = mod(Math.round(target / W), n);
      if(i === live) return;                       /* the active card keeps its normal clicks */
      e.preventDefault(); e.stopPropagation();
      var d1 = mod(i - live, n);
      var delta = d1 > n / 2 ? d1 - n : d1;
      target = (Math.round(target / W) + delta) * W;
      animate();
    }, true);

    var rz, rzW = window.innerWidth;
            window.addEventListener('resize', function(){
    /* WIDTH-ONLY (client 2026-08-21: "sliding fast on top and bottom the things got broken for few seconds"). On a phone the browser bar slides away as you scroll and back as you stop, and each time that is a `resize` — of HEIGHT only. This handler used to re-run layout() regardless, so every carousel on the page re-measured, snapped back to its nearest card and rebuilt its chrome a tenth of a second into every fast scroll. Nothing here depends on the height, so a resize that leaves the width alone is ignored. */
    if(window.innerWidth === rzW) return;
    rzW = window.innerWidth;
    clearTimeout(rz); rz = setTimeout(layout, 100);
  });
    window.addEventListener('load', layout);
    /* re-measure once the real font is in — fallback-font text under-measures heights */
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ layout(); });
    layout();
    root.classList.add('custom-bsl3k--ready');
  }
};

/* Sections cannot know whether this file has finished loading when their own inline
   script runs, so they push their root onto a queue and this drains it. Works in both
   orders: if the asset landed first the section's push is followed by its own drain
   call; if it landed second, the drain below picks up everything already queued. */
window.candyBsl3kDrain = function(){
  var q = window.__bsl3kQueue || [];
  while(q.length) window.candyBsl3kSlider(q.shift());
};
window.candyBsl3kDrain();
if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', window.candyBsl3kDrain);
}
